import { render, staticRenderFns } from "./arviointi-form.vue?vue&type=template&id=725865d8&scoped=true&"
import script from "./arviointi-form.vue?vue&type=script&lang=ts&"
export * from "./arviointi-form.vue?vue&type=script&lang=ts&"
import style0 from "./arviointi-form.vue?vue&type=style&index=0&id=725865d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725865d8",
  null
  
)

export default component.exports